module.exports = __webpack_public_path__ + "media/product/marker-line@2x-281a256d.png";